import React, { useState, useRef, useEffect } from "react";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import { API } from "../../assets/staticData";

export default function ChangePasswordModal({
  open,
  onClose,
  userId,
  setRefresh,
}) {

  const [fields, setFields] = useState({
    password: "",
    confirm: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setFields({ password: "", confirm: "" });
      setError("");
    }
  }, [open]);


  const handleChange = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async () => {
    if (!fields.password || !fields.confirm) {
      setError("Both fields are required.");
      return;
    }
    if (fields.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (fields.password !== fields.confirm) {
      setError("Passwords do not match.");
      return;
    }

    try {
      let token = localStorage.getItem("userToken");

      const res = await fetch(`${API}/user/set-password`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword: fields.password, id: userId }),
      });
      if (res.ok) {
        onClose();
        setFields({ password: "", confirm: "" });
        toast("Password updated successfully!", { type: "success" });
        setRefresh && setRefresh((r) => !r);
      } else {
        const data = await res.json();
        setError(data.error?.message || "Error updating password.");
      }
    } catch (err) {
      setError("Error updating password.");
    }
  };

  if (!open || !userId) return null;

  return (
    <div
      className="absolute flex bg-gray-500 bg-opacity-40 w-svw h-svh top-0 left-0 transition-all delay-200 z-50"
      style={{ alignItems: "center", justifyContent: "center" }}
    >
      <div
        className="bg-white p-8 rounded-md flex-col gap-5 min-w-[350px]"
        style={{
          display: "flex",
          boxShadow: "0 2px 18px 2px #0002",
        }}
      >
        <h3>Change Password</h3>
        <TextField
          label="New Password"
          name="password"
          type="password"
          sx={{ m: 1, width: 300 }}
          value={fields.password}
          onChange={handleChange}
          autoComplete="new-password"
        />
        <TextField
          label="Confirm New Password"
          name="confirm"
          type="password"
          sx={{ m: 1, width: 300 }}
          value={fields.confirm}
          onChange={handleChange}
          autoComplete="new-password"
        />
        {error && (
          <div className="text-red-600 text-sm mt-2">{error}</div>
        )}
        <div
          className="bg-blue-500 w-full flex py-3 mt-4 rounded-md text-white hover:bg-blue-600 transition-all delay-100 cursor-pointer justify-center"
          onClick={handleSubmit}
        >
          Save New Password
        </div>
        <div
          className="mt-2 text-sm text-gray-500 cursor-pointer underline text-center"
          onClick={onClose}
        >
          Cancel
        </div>
      </div>
    </div>
  );
}
